import React, { forwardRef, memo, ReactNode, RefObject } from 'react';
import styles from './Subheader.module.scss';
import { Button, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { ProfileImage } from 'new/elements/ProfileImage';
import { useHistory } from 'react-router-dom';

interface SubheaderProps {
  profileImage?: string;
  showAvatar?: boolean;
  title?: string;
  subtitle?: string | ReactNode;
  onClickBack?: () => void;
  RightComponent?: ReactNode;
  RightAfterTitleComponent?: ReactNode;
  TitleComponent?: ReactNode;
  hideBackButton?: boolean;
}

const SubheaderComponent = forwardRef<HTMLDivElement, SubheaderProps>(
  (props: SubheaderProps, ref: RefObject<HTMLDivElement>) => {
    const {
      profileImage,
      showAvatar,
      title,
      onClickBack,
      RightComponent,
      TitleComponent,
      subtitle,
      hideBackButton,
      RightAfterTitleComponent,
    } = props;
    const history = useHistory();

    const onLocalClickBack = () => {
      if (onClickBack) {
        onClickBack();
      } else {
        history.goBack();
      }
    };

    return (
      <div ref={ref} className={styles.header}>
        {!hideBackButton ? (
          <Button
            onClick={onLocalClickBack}
            startIcon={<ArrowBack />}
            variant="text"
            color="primary"
          >
            Back
          </Button>
        ) : null}

        <div className={styles.profile}>
          {TitleComponent || (
            <>
              {profileImage || showAvatar ? (
                <ProfileImage fullName={title} source={profileImage} size="small" />
              ) : null}
              <div className={styles.titleContainer}>
                <Typography variant="subtitle1">{title}</Typography>
                {subtitle ? subtitle : null}
              </div>
            </>
          )}

          {RightAfterTitleComponent ? (
            <div className={styles.rightAfterTitleComponent}>{RightAfterTitleComponent}</div>
          ) : null}
        </div>

        <div className={styles.right}>{RightComponent}</div>
      </div>
    );
  },
);

export const Subheader = memo(SubheaderComponent);
